/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateResellerRequest
 */
export interface UpdateResellerRequest {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    invoiced?: boolean;
    /**
     * 
     */
    spNewPricing?: boolean;
}

/**
 * Check if a given object implements the UpdateResellerRequest interface.
 */
export function instanceOfUpdateResellerRequest(value: object): value is UpdateResellerRequest {
    return true;
}

export function UpdateResellerRequestFromJSON(json: any): UpdateResellerRequest {
    return UpdateResellerRequestFromJSONTyped(json, false);
}

export function UpdateResellerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateResellerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'invoiced': json['invoiced'] == null ? undefined : json['invoiced'],
        'spNewPricing': json['spNewPricing'] == null ? undefined : json['spNewPricing'],
    };
}

export function UpdateResellerRequestToJSON(json: any): UpdateResellerRequest {
    return UpdateResellerRequestToJSONTyped(json, false);
}

export function UpdateResellerRequestToJSONTyped(value?: UpdateResellerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'invoiced': value['invoiced'],
        'spNewPricing': value['spNewPricing'],
    };
}

